export { default } from './AvatarWithIcon';
